import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import Tabs, { TabItem } from "../../../../../common/components/xepp/tab/Tabs";
import { TeamMembersPage, TeamMembersTabHandle } from "./TeamMembersPage";
import { InvitedTeamMembersPage } from "./InvitedTeamMembersPage";
import TeamMemberSideDialog from "./TeamMemberSideDialog";
import { UtilityPermissions } from "../../../../../model/permissions/permissions";

const TeamMembersTabs = () => {

    const [activeTab, setActiveTab] = useState("members");
    const [addNewTeamMemberOpen, setAddNewTeamMemberOpen] = useState(false)

	const tabs: TabItem[] = [
		{
			key: "members",
			label: "Members",
			content: <TeamMembersPage />,
			actionButton: {
				text: "Invite Member",
				onClick: () => {
					showAddNewTeamMember();
				},
				permission: UtilityPermissions.AddNewUtilityUser
			}
		},
		{
			key: "intvited",
			label: "Invited",
			content: <InvitedTeamMembersPage />,
			actionButton: {
				text: "Invite Member",
				onClick: () => {
					showAddNewTeamMember();
				},
				permission: UtilityPermissions.AddNewUtilityUser
			}
		},
	];

    const showAddNewTeamMember = () => {
        setAddNewTeamMemberOpen(true);
    }
    const hideAddNewTeamMember = () => {
        setAddNewTeamMemberOpen(false);
    }

    
	return (
        <>
			<Tabs tabs={tabs} activeTab={activeTab} onTabChange={key => setActiveTab(key)} hideBorder={true} />
        
            {addNewTeamMemberOpen && <TeamMemberSideDialog isEdit={false} onCloseDialog={hideAddNewTeamMember} onDone={hideAddNewTeamMember} user={undefined}/>}
                
        </>
	);

}

export default TeamMembersTabs;